'use client';

import { useTranslations } from 'next-intl';
import {
  BlocksCheckboxChangeEvent,
  CatAccordionPanel,
  CatHeading
} from 'components/blocks-components';
import { ListMenu, ListMenuType } from '@cat-ecom/pcc-components';
import { FacetTypes as SearchFacetTypes } from 'services/internalSearch/types';
import { FacetTypes as CategoryFacetTypes } from 'services/internal-product-list/types';
import { getFacetItems } from '../utils';
import styles from '../specifications.module.scss';
import cx from 'classnames';

type AccordionSpecificationItemProps = {
  label: string;
  value: SearchFacetTypes[] | CategoryFacetTypes[];
  handleItemClick: (e: BlocksCheckboxChangeEvent) => void;
  selectedFacets: string | string[];
  classNames?: { className: string };
};

export const AccordionSpecificationItem = ({
  label,
  value,
  handleItemClick,
  selectedFacets,
  classNames
}: AccordionSpecificationItemProps) => {
  const t = useTranslations();

  return (
    <CatAccordionPanel
      alignToggleRight
      key={label}
      disabled={value.length === 0}
      className={cx(
        styles['specifications__accordion_body'],
        classNames?.className
      )}
    >
      <div slot="header">
        <CatHeading
          slot="header"
          variant="label"
          level="h2"
          className={styles['specifications__accordion_facets-label']}
        >
          {label}
        </CatHeading>
      </div>
      <ListMenu
        listItems={getFacetItems(value, selectedFacets)}
        handleItemClick={handleItemClick}
        buttonViewLessText={t('VIEW_LESS_BUTTON')}
        buttonViewMoreText={t('VIEW_MORE_PRODUCTS')}
        type={ListMenuType.CHECKBOX}
        defaultItemsCount={value.length}
      />
    </CatAccordionPanel>
  );
};
